<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column fitting- -border-radius-1">
      <div class="-header large-">
        <div class="-wrapper-column">
          <div v-if="'AM'=== userInfo.auth">

            <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_product_used_cost.title') }}
              <g-tooltip-wrapper>
                <g-icon name="info" color="lightgray-4" class="-ml-1"></g-icon>
                <g-tooltip direction="right">
                  <span v-html="$t('pages_dashboard_product_chart.tooltip')" />
                </g-tooltip>
              </g-tooltip-wrapper>
            </p>
          </div>
          <div v-else>
            <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_product_used_cost.title.AM') }}
              <g-tooltip-wrapper>

                <g-icon name="info" color="lightgray-4" class="-ml-1"></g-icon>
                <g-tooltip direction="right">
                  <span v-html="$t('pages_dashboard_product_chart.tooltip')" />
                </g-tooltip>
              </g-tooltip-wrapper>
            </p>
          </div>


          <p class="-font-size-12 -color-gray-1">{{ showMonthBefore }} ~ {{ showMonthAfter }}</p>
        </div>
        <div class="-wrapper">
          <div class="dropDown-wrap custom-select">
            <g-dropdown
              id="dashboard-product-chart-select-month"
              value="-5"
              text-class="-mx-0 -pr-0 -pl-2"
              @change="onChangeProducts"
            >
              <g-dropdown-item-wrap class="-width-100 -bg-white -box-shadow-level-4">
                <g-dropdown-item value="-2" text="Last 3 Months"  ></g-dropdown-item>
                <g-dropdown-item value="-5" text="Last 6 Months" selected></g-dropdown-item>
                <g-dropdown-item value="-8" text="Last 9 Months" ></g-dropdown-item>
                <g-dropdown-item value="-11" text="Last 12 Months" ></g-dropdown-item>
              </g-dropdown-item-wrap>
            </g-dropdown>
          </div>
          <div class="-toggle-button -pl-2" id="dashboard-product-chart-equlizer">
            <button type="button" name="button" :class="{'selected-': isEqulizer}" @click="onToggleIsLineGraph(false)">
              <span class="material-icons">equalizer</span>
            </button>
            <button type="button" name="button" :class="{'selected-': isTimeline}" @click="onToggleIsLineGraph(true)">
              <span class="material-icons">timeline</span>
            </button>
          </div>
        </div>
      </div>
      <div class="-bg-white -wrapper-h-v-center" style="height:300px;">
        <am-xy-chart-2
          id="dashboard-product-chart"
          refName="prodcuctUseCostChart"
          :filter="productsSeriesList"
          :chart-data="products"
          :stacked="true"
          :series-type="seriesType"
          @hit="onHit"
          :mouse-cursor-style="MOUSE_CURSOR.pointer"
        />
      </div>
    </section>
  </div>
</template>

<script>
import AmXyChart2 from '../../components/AmXyChart2'
import SpanDropdown from './components/SpanDropdown'
import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP} from "@/constants/constants";
import {MOUSE_CURSOR} from '@/code/CodeChart'
import moment from "moment";

export default {
  name: 'prodcuct-use-cost',
  componentName: 'ProdcuctUseCost',
  components: {
    AmXyChart2,
    [SpanDropdown.name]: SpanDropdown
  },
  data () {
    return {
      chartData: [],
      filter: [],
      isLineGraph: false,
      open: false,
      param: {},
      AUTH_GROUP : AUTH_GROUP,
      MOUSE_CURSOR: MOUSE_CURSOR,
      showMonthAfter : '',
      showMonthBefore : ''
    }
  },
  computed : {
    ...mapGetters('dashboard', ['products', 'productsSeriesList', 'productsMonth', 'customerList']),
    ...mapGetters('user', ['userInfo']),
    isEqulizer () {
      return !this.isLineGraph
    },
    isTimeline () {
      return this.isLineGraph
    },
    seriesType () {
      return this.isLineGraph ? 'LineSeries' : 'ColumnSeries'
    }
  },
  methods: {
    ...mapActions('dashboard', ['getCustomersSales', 'getProductChartData', 'setProductsMonth']),
    onToggleIsLineGraph (isLineGraph) {
      this.isLineGraph = isLineGraph
    },
    onChangeProducts(value) {
      this.setProductsMonth(value)
    },
    changeShowMonth(){
      this.showMonthAfter = moment(new Date()).format("YYYY/MM")
      this.showMonthBefore = moment(this.param.endMonth).add(this.productsMonth, "M").format("YYYY/MM")
      this.param.endMonth = this.showMonthAfter.replace('/', '')
      this.param.startMonth = this.showMonthBefore.replace('/', '')
    },
    onHit (e) {
      if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        this.$router.push('/product/rank?selectMonth='+e.target.dataItem.categoryX)
      } else {
        this.$router.push('/product/usedAmountProduct?selectMonth='+e.target.dataItem.categoryX)
      }
    }
  },
  mounted() {
    this.changeShowMonth()
    if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      this.param.empNo = ""
      this.param.customerDepts = [{ customerCode : this.userInfo.customerCode, deptCode : this.userInfo.customerDeptCode, checked : true }]
      this.getProductChartData(this.param)
    }else if(this.userInfo.auth === AUTH_GROUP.BespinSales){
      this.param.customerDepts = this.customerList
      this.param.empNo = this.userInfo.empNo
    }else {
      this.param.customerDepts = this.customerList
    }
  },
  watch : {
    productsMonth() {
      this.showMonthAfter = moment(new Date()).format("YYYY/MM")
      this.showMonthBefore = moment(this.param.endMonth).add(this.productsMonth, "M").format("YYYY/MM")
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/home/components/ProdcuctUseCost.vue